import { Form, Formik, FormikValues } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

import FormikButton from '../../../common/formik/FormikButton';
import FormikGrid from '../../../common/formik/FormikGrid';
import FormikSelectField, { FormikSelectOptions } from '../../../common/formik/FormikSelectField';
import FormikTextField from '../../../common/formik/FormikTextField';
import { useCreateWorkflow } from '../Workflow.hooks';
import { WorkflowDto } from '../Workflow.interface';
import { useFindTaskTypes } from '../../task-types/TaskType.hooks';

export interface WorkflowCreateDialogProps {
  open: boolean;
  onCancel?: () => void;
  onCreated?: (workflow: WorkflowDto) => void;
}

const WorkflowCreateDialog: React.FC<WorkflowCreateDialogProps> = ({
  open,
  onCancel,
  onCreated
}) => {
  const formikRef = useRef<FormikValues>();
  const {
    createdWorkflow,
    isCreating,
    createError,
    createWorkflow
  } = useCreateWorkflow();

  const [{ data: taskTypes }, findTaskTypes] = useFindTaskTypes();
  const [options, setOptions] = useState<FormikSelectOptions[]>([]);

  useEffect(() => {
    if (Array.isArray(taskTypes) && taskTypes.length) {
      setOptions(taskTypes.map(t => {
        return { label: t.label, value: t.name };
      }));
    } else {
      findTaskTypes();
    }
  }, [taskTypes, findTaskTypes]);

  useEffect(() => {
    if (!isCreating) {
      if (onCreated && createdWorkflow) {
        onCreated(createdWorkflow);
      }
      if (formikRef && formikRef.current) {
        formikRef.current.setSubmitting(false);
      }
    }
  }, [createdWorkflow, isCreating, onCreated]);

  return (
    <Dialog maxWidth='xs' open={open} onClose={onCancel}>
      <Formik
        innerRef={(formik: any) => (formikRef.current = formik)}
        initialValues={{
          name: '',
          taskType: ''
        }}
        validationSchema={Yup.object({
          name: Yup.string().required('Required'),
          taskType: Yup.string()
        })}
        onSubmit={(form: any) => createWorkflow(form)}
      >
        <Form autoComplete='off'>
          <DialogTitle>Create Workflow</DialogTitle>
          <DialogContent>
            <FormikGrid>
              <FormikTextField
                autoFocus
                type='text'
                name='name'
                label='Workflow Name'
              />
              {/* <FormikTextField type='text' name='code' label='Code' /> */}
              <FormikSelectField
                name='taskType'
                label='Task Type'
                options={[{ label: 'Any', value: '' }, ...options]}
              />
            </FormikGrid>
            {createError && (
              <Alert severity='error'>{`Error occurred. ${createError.message}`}</Alert>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={onCancel}>Cancel</Button>
            <FormikButton>Create</FormikButton>
          </DialogActions>
        </Form>
      </Formik>
    </Dialog>
  );
};

export default WorkflowCreateDialog;
